import { useTranslation } from "react-i18next";
import { GetIcon } from "../../../../icons";
import { dateFormat, dateTimeFormat, timeFormat } from "../../../functions/date";
import { IconBox, Img, Status } from "../styles";
export function convertMinutesToHHMM(minutes) {
  const hours = Math.floor(minutes / 60);
  const mins = Math.floor(minutes % 60);

  const hoursStr = hours.toString().padStart(2, "0");
  const minsStr = mins.toString().padStart(2, "0");

  return `${hoursStr}:${minsStr}`;
}
export const GetValue = (attribute, itemValue, display = false, language = "de") => {
  const [t] = useTranslation();
  console.log(attribute.name, itemValue)
  let response = "";
  switch (attribute.type) {
    case "minute":
      response = convertMinutesToHHMM(parseFloat(itemValue ?? 0));
      break;
    case "image":
      response = <Img src={process.env.REACT_APP_CDN + itemValue} />;
      break;
    case "file":
      response = (
        <a href={process.env.REACT_APP_CDN + itemValue} download>
          download
        </a>
      );
      break;
    case "datetime":
      response = dateTimeFormat(itemValue);
      break;
    case "multiSelect":
      // console.log(itemValue, attribute)
      response = Array.isArray(itemValue) && itemValue?.map((item) => item[attribute.showItem]?.toString())?.join(", ");
      break;
    // case "multiSelect":
    //                   if (attribute.apiType === "JSON") {
    //                     const item = attribute.selectApi
    //                       .filter((item) => item.id.toString() === data[attribute.name]?.toString())
    //                       .map((filteredItem, index) => {
    //                         if(index === attribute.selectApi.filter((item) => item.id.toString() === data[attribute.name]?.toString()).length - 1){
    //                         return item[attribute.showItem]?.toString()
    //                       }
    //                         else{
    //                           return item[attribute.showItem]?.toString() + ", "
    //                         }
    //                       });
    //                     return item.length > 0 ? item : <Td>N/A</Td>;
    //                   } else if (attribute.apiType === "CSV") {
    //                     return (
    //                       <Td onClick={openRowData} key={index}>
    //                         {data[attribute.name] ?? "Nil"}
    //                       </Td>
    //                     );
    //                   } else {
    //                     return (
    //                       <Td onClick={openRowData} key={index}>
    //                         {data[attribute.name]?.map((val,idx)=> {
    //                           if(idx===data[attribute.name]?.length-1){
    //                             return t(val[attribute.showItem] ?? "Nil")
    //                           }
    //                           else{
    //                             return t(val[attribute.showItem] ?? "Nil")+", "
    //                           }
    //                          }) }
    //                       </Td>
    //                     );
    //                   }
    case "date":
      response = dateFormat(itemValue);
      break;
    case "time":
      response = timeFormat(itemValue);
      break;
    case "expired":
      let status;

      if (typeof itemValue === 'string') {
        // Check if it's a valid date string
        const dateObj = new Date(itemValue);
        if (!isNaN(dateObj.getTime())) {
          // Compare only the date part, ignore time
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          dateObj.setHours(0, 0, 0, 0);
          status = dateObj >= today
          ? <Status color={"green"}>{t("active")}</Status>
          : <Status color={"red"}>{t("inactive")}</Status>;
        } else {
          // Handle string cases ("open" or "close")
          if (itemValue.toLowerCase() === 'new') {
            status = <Status color={"#3498DB"}>{t("new")}</Status>;
          } else if (itemValue.toLowerCase() === 'open') {
            status = <Status color={"green"}>{t("open")}</Status>;
          } else if (itemValue.toLowerCase() === 'close') {
            status = <Status color={"red"}>{t("close")}</Status>;
          } else if (itemValue.toLowerCase() === 'in_progress') {
            status = <Status color={"#ecec00"}>{t("In progress")}</Status>;
          } else {
            status = "";
          }
        }
      } else if (typeof itemValue === 'boolean') {
          itemValue
        ? status = <Status color={"green"}>{t("active")}</Status>
        : status = <Status color={"red"}>{t("inactive")}</Status>;
      } else if (itemValue instanceof Date || !isNaN(new Date(itemValue))) {
        // Handle date cases
        status = new Date(itemValue) > new Date()
          ? <Status color={"green"}>{t("active")}</Status>
          : <Status color={"red"}>{t("inactive")}</Status>;
      } else {
        // Handle null/undefined or other cases
        status = <Status color={"red"}> {t(attribute.ifNull)}</Status>;
      }

      response = status;
      break;
    case "color":
      response = <div style={{ backgroundColor: itemValue, height: "20px", width: "40px" }}></div>;
      break;
    case "number":
      response = itemValue?.toString().length === 0 || isNaN(itemValue) ? t(`na`) : itemValue;
      break;
    case "textarea":
    case "htmleditor":
      response = <span style={{wordWrap: 'break-word', overflowWrap: 'anywhere', whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{ __html: itemValue?.toString()?.substring(0, 200) }}></span>;
      break;
    case "checkbox":
      response = <IconBox className={display && "display"}>{itemValue ? <GetIcon icon={"checked"} /> : <GetIcon icon={"Close"} />}</IconBox>;
      break;
    case "icon":
      response = <i className={`fa-light ${itemValue}`} />;
      break;
    default:
      {console.log("jvdguv ujf:", itemValue, typeof itemValue, attribute.name, typeof attribute.name, attribute.name==="")}
      switch (typeof itemValue) {
        case "undefined":
          response = "--";
          break;
        case "object":
          response = itemValue ? (attribute.showItem==="locale" ? itemValue[sessionStorage.getItem("_lang") ?? "de"] ?? '--' : t(itemValue?.[attribute.showItem]) ?? "--") : '--';
          break;
        case "boolean":
          response = itemValue.toString();
          break;
        case "number":
          response = itemValue?.toString().length === 0 || isNaN(itemValue) ? t(`na`) : itemValue;
          break;
        case "string":
        default:
          if (attribute.type === "select" && attribute.apiType === "JSON") {
            attribute.selectApi.filter((item) => item.id.toString() === itemValue?.toString()).map((filteredItem) => (response = filteredItem.value));
          } else if(attribute.name===""){
            response = "";
          } else {
            response = itemValue?.startsWith("http") ? <a style={{color: '#55188b'}} href={itemValue} target="_blank" rel="noopener noreferrer">{itemValue}</a> : itemValue?.toString().substring(0, 200);
          }
          break;
      }
  }
  if (response?.length === 0 && attribute.name !== "") {
    return t(`na`);
  }
  return response;
};

